import { resolveAg26Variation } from './ag26-path';

/**
 * Detects the `st_ag26` (UAE Marketing DCB / "3 steps") v5 variation.
 *
 * Works across the whole funnel:
 * - Landing page: the first path segment is `st_ag26`.
 * - OTP / thank-you (`/confirm-pin`, `/thankyou`): fall back to the referrer
 *   URL, a dedicated session flag, and finally `homeData.source`.
 * Other variation landings never match and clear the ag26 session flags.
 */
export const isStAg26Variation = (): boolean => resolveAg26Variation('st_ag26');
